import React from 'react'

export const ArrowExternal = () => {
    return <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.70298 5.73722C5.70298 5.40585 5.97161 5.13722 6.30298 5.13722H10.8628V9.69701C10.8628 10.0284 10.5942 10.297 10.2628 10.297C9.93141 10.297 9.66278 10.0284 9.66278 9.69701V7.18575L6.16156 10.687C5.92725 10.9213 5.54735 10.9213 5.31303 10.687C5.07872 10.4526 5.07872 10.0727 5.31303 9.83843L8.81425 6.33722H6.30298C5.97161 6.33722 5.70298 6.06859 5.70298 5.73722Z" fill="white"/>
    </svg>    
}